import { ListingItem, ListingsTab, ListingsTabs } from '../../components';
// import {
//   mockAssetListings,
//   mockActiveListings,
//   mockPendingListings,
//   mockSoldListings,
//   mockUnsoldListings,
//   mockReferredListings,
// } from '../../mock-data/listings';
import { get, Paginated } from '../api';
import type { APIListingItem } from './types';
import { mapAPIListing } from './mappers';

export const endpoints = {
  activeListingsUrl: `${window.envConfig.SELLERS_API_BASE_URL}listings/active`,
  pendingListingsUrl: `${window.envConfig.SELLERS_API_BASE_URL}listings/pending`,
  soldListingsUrl: `${window.envConfig.SELLERS_API_BASE_URL}listings/sold`,
  unsoldListingsUrl: `${window.envConfig.SELLERS_API_BASE_URL}listings/unsold`,
  assetForSaleListingsUrl: `${window.envConfig.SELLERS_API_BASE_URL}listings/assetforsale`,
  referredListingsUrl: `${window.envConfig.SELLERS_API_BASE_URL}listings/referred`,
};

export const getListings = async (
  token: string,
  listingsType: ListingsTab,
  urlParams: Record<string, string>
): Promise<Paginated<ListingItem> | void> => {
  const paginated = true;
  switch (listingsType) {
    case ListingsTabs.Pending:
      return get<Paginated<APIListingItem>>({
        url: endpoints.pendingListingsUrl,
        urlParams,
        paginated,
        token,
      }).then(mapApiResponse);
    // return {
    //   data: mockPendingListings,
    //   pagination: {
    //     pageNumber: Number(urlParams?.pageNumber ?? 1),
    //     itemCount: 30,
    //     pageCount: 3,
    //   },
    // };
    case ListingsTabs.Sold:
      return get<Paginated<APIListingItem>>({
        url: endpoints.soldListingsUrl,
        urlParams,
        paginated,
        token,
      }).then(mapApiResponse);
    // return {
    //   data: mockSoldListings,
    //   pagination: {
    //     pageNumber: Number(urlParams?.pageNumber ?? 1),
    //     itemCount: 30,
    //     pageCount: 3,
    //   },
    // };
    case ListingsTabs.Unsold:
      return get<Paginated<APIListingItem>>({
        url: endpoints.unsoldListingsUrl,
        urlParams,
        paginated,
        token,
      }).then(mapApiResponse);
    // return {
    //   data: mockUnsoldListings,
    //   pagination: {
    //     pageNumber: Number(urlParams?.pageNumber ?? 1),
    //     itemCount: 30,
    //     pageCount: 3,
    //   },
    // };
    case ListingsTabs.Active:
      return get<Paginated<APIListingItem>>({
        url: endpoints.activeListingsUrl,
        urlParams,
        paginated,
        token,
      }).then(mapApiResponse);
    // return mapApiResponse({
    //   data: mockActiveListings,
    //   pagination: {
    //     pageNumber: Number(urlParams?.pageNumber),
    //     itemCount: 30,
    //     pageCount: 3,
    //   },
    // });
    case ListingsTabs.AssetForSale:
      return get<Paginated<APIListingItem>>({
        url: endpoints.assetForSaleListingsUrl,
        urlParams,
        paginated,
        token,
      }).then(mapApiResponse);
    // return mapApiResponse({
    //   data: mockAssetListings,
    //   pagination: {
    //     pageNumber: Number(urlParams?.pageNumber),
    //     itemCount: 30,
    //     pageCount: 3,
    //   },
    // });
    case ListingsTabs.Referred:
      return get<Paginated<APIListingItem>>({
        url: endpoints.referredListingsUrl,
        urlParams,
        paginated,
        token,
      }).then(mapApiResponse);
    // return mapApiResponse({
    //   data: mockReferredListings,
    //   pagination: {
    //     pageNumber: Number(urlParams?.pageNumber),
    //     itemCount: 30,
    //     pageCount: 3,
    //   },
    // });
  }
};

export function mapApiResponse(
  payload: Paginated<APIListingItem>
): Paginated<ListingItem> {
  return {
    ...payload,
    data: payload.data.map(mapAPIListing),
  };
}
